import React, { useEffect } from 'react';
import Header from './components/Header';
import Home from './components/Home';

function App() {
  useEffect(() => {
    if (
      window.location.pathname === '/mcp' ||
      window.location.pathname === '/mcp/'
    ) {
      window.location.replace('/mcp/index.html');
    }
  }, []);

  return (
    <div className="app-container">
      <Header />
      <main className="main-content">
        <Home />
      </main>
    </div>
  );
}

export default App;
